export enum TrackType {
  Keys = 'keys',
  Items = 'items',
  Quests = 'quests',
}
